<template>
    <section
        :data-component-name="$options.name"
        class="o-grid o-grid-12 o-form__section"
        :class="{
            'step-section': section.isStep,
            'prev-section': section.isStep && section.stepIndex < currentStep,
            'next-section': section.isStep && section.stepIndex > currentStep,
            'current-section': section.isStep && section.stepIndex == currentStep,
            'hidden-fields-section': isHiddenFieldsSection,
        }"
    >

        <component
            v-for="(field, fi) in section.fields"
            :key="field.id"
            :is="field.type"
            :field="field"
            :disabledIDs="disabledIDs"
            :sectionTitle="(fi==0)? section.title : null"
        />

    </section>
</template>

<script>

export default {
    name: 'FormSection',
    props: {
    	section:{
    		type: Object,
            default() { return {} },
        },
        currentStep:{
            type: Number,
            default() { return 0 },
        },
        totalSteps:{
            type: Number,
            default() { return 0 },
        },
        disabledIDs:{
            type: Array,
            default() { return [] },
        },
    },
    computed: {
        isHiddenFieldsSection() {
            let isHidden = false;
            let fieldTypes = {};

            this.section.fields.forEach(field => {
                if (!field.fieldsList) return;
                field.fieldsList.forEach(subField => {
                    fieldTypes[subField.inputType] = true;
                });
            });

            if (Object.keys(fieldTypes).length == 1 && fieldTypes['hidden']) {
                return true;
            }
            return false;
        },
    },
    watch: {
        currentStep: function (current, old) {
            if (old == this.section.stepIndex && this.section.scriptOnLeave) {
                try {
                    eval(this.section.scriptOnLeave);
                } catch (e) {
                    console.error(e);
                }
            }
            if (current == this.section.stepIndex && this.section.scriptOnEnter) {
                try {
                    eval(this.section.scriptOnEnter);
                } catch (e) {
                    console.error(e);
                }
            }
        },
    },
}

</script>